import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import { MeasuredAsMetricDenominator } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/MeasuredAsField/MeasuredAsMetricDenominator';
import { useGetMeasuredAsDisplayName } from '@modules/quantify/hooks';
import { Stack, Typography } from '@mui/material';

export function MeasuredAsPreview() {
  const isAnalysisLoading = useAnalysisStore(({ isLoading }) => isLoading);
  const measuredAsDisplayName = useGetMeasuredAsDisplayName();

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Measured as:</Typography>
      <LoadingTypography
        variant="body2"
        color="primary"
        skeletonWidth="100%"
        isLoading={isAnalysisLoading}
      >
        {measuredAsDisplayName}
      </LoadingTypography>
      {<MeasuredAsMetricDenominator isReadOnly />}
    </Stack>
  );
}
